import { RegionShared } from "@1games-ru/region-shared";
import { RpcMpProviderFailedResponse } from "@/core/rpc-mp-provider/responses/rpc-mp-provider-failed-response";
import { RpcMpProviderSuccessResponse } from "@/core/rpc-mp-provider/responses/rpc-mp-provider-success-response";
import RpcMpProvider from "@/core/rpc-mp-provider/rpc-mp-provider";

export default class WorldMpProvider {
  public static async getWorldTime(): Promise<
    | RpcMpProviderFailedResponse
    | RpcMpProviderSuccessResponse<typeof RegionShared.Backend.Responses.GetWorldTimeResponse>
  > {
    return RpcMpProvider.getInstance().callServer<
      typeof RegionShared.Backend.Requests.GetWorldTimeRequest,
      typeof RegionShared.Backend.Responses.GetWorldTimeResponse
    >(RegionShared.Backend.Events.World.GetWorldTime, {});
  }
}
